export default function BottomButtons({
  style,
  children,
}: {
  style?: React.CSSProperties;
  children: React.ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: 30,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
